import { gatewayInstance } from "../server/gateway";
import { request } from "@/components/Projects/api";
import { WorkStatusItem } from "@/components/Modals/WorkStatusModal";
import { FocusSDK } from "@/utils";
import { EmplApproveList, PageExternalContactsApprInfoReqParam } from "@/types/chat/State";
import { getEbookDeptInfoList } from "@/components/AddressBook/common";
import { getDeptPositionDesc } from "@/models/user";
import ImService from "@/server/ImService";

export function getIsGovAddressBook() {
  return FocusSDK.getApplicationInfo().isGovEbook;
}

export function addressBookApiConfig() {
  const isGovAddressBook = getIsGovAddressBook();
  if (isGovAddressBook) {
    return {
      ebookSimpleVirtualOrgInfo: "ebook.gov.getEbookSimpleVirtualOrgInfo",
      simpleDeptInfo: "ebook.gov.getEbookGovFatherDeptInfo",
      ebookOrgInfo: "ebook.gov.getEbookOrgInfo",
      ebookDeptInfo: "ebook.gov.getEbookDeptInfo",
      ebookUserDetail: "ebook.gov.userebookdetail",
      virtualUserDetail: "ebook.gov.getVirtualUserEbookDetail"
    };
  } else {
    return {
      ebookSimpleVirtualOrgInfo: "ebook.getEbookSimpleVirtualOrgInfo",
      simpleDeptInfo: "ebook.getEbookDeptInfo",
      ebookOrgInfo: "",
      ebookDeptInfo: "ebook.getEbookDeptInfo",
      ebookUserDetail: "ebook.gov.userebookdetail",
      virtualUserDetail: "ebook.userebookdetail"
    };
  }
}

/**
 * 虚拟部门数据
 * @returns
 * @param body
 */
export async function getEbookSimpleVirtualOrgInfo(body: {
  appId?: string;
  virtualOrgId?: string;
}) {
  return gatewayInstance.request({
    api: addressBookApiConfig().ebookSimpleVirtualOrgInfo,
    method: "POST",
    // @ts-ignore
    body
  });
}
export async function getPersonalDetail(body: any = {}) {
  return gatewayInstance.request({
    api: "ebook.gov.getPersonalDetail",
    method: "POST",
    body
  });
}
export async function applyFriend(data: any = {}, accessPhone?: any) {
  return gatewayInstance.request({
    api: "efriend.applyFriend",
    method: "POST",
    body: {
      accessPhone,
      app: data.appId,
      info: data.validationMsg,
      labelId: "",
      pin: data.userId,
      realName: data.fields.find((item: any) => item.key === "name")?.val,
      teamId: data.teamId,
      remark: data.remark
    }
  });
}

export function getUserEbookDetailList(
  users: {
    appId: string;
    userId: string;
    teamId: string;
  }[]
) {
  try {
    const result = gatewayInstance.request({
      api: "ebook.gov.getUserEbookDetailList",
      method: "POST",
      // @ts-ignore
      body: { ebookUserDetailReqList: users }
    });
    return result;
  } catch (error) {
    return null;
  }
}

export function getUserEbookDetail(user: {
  appId: string;
  userId: string;
  teamId: string;
  isMulti: boolean;
  needMask?: boolean; // 是否需要mask掉关键信息，needMask: true/false。不传即为false
  isFromBusinessCard?: boolean; // true/false, 只有来自名片页的请求才返回标签
  needMaskName?: boolean; // 单位沟通对接人的姓名脱敏
}) {
  try {
    const result = gatewayInstance.request({
      api: addressBookApiConfig().ebookUserDetail,
      method: "POST",
      // @ts-ignore
      body: { ...user }
    });
    return result;
  } catch (error) {
    return null;
  }
}

// 获取常用联系人成员列表
export function getGroupMemberList() {
  try {
    const result = gatewayInstance.request({
      api: "screen.queryGroupMemberList",
      method: "POST",
      // @ts-ignore
      body: {}
    });
    return result;
  } catch (error) {
    return null;
  }
}

/**
 * 批量添加人员或设备到组内
 * @param body
 * @returns
 */
export async function batchAddGroupMember(body: {
  groupId: string;
  memberList: {
    memberId: string;
    memberType: 1 | 2;
  }[];
}) {
  try {
    const result = await gatewayInstance.request({
      api: "screen.batchAddGroupMember",
      method: "POST",
      // @ts-ignore
      body
    });
    return result;
  } catch (error) {
    return null;
  }
}

/**
 * 创建组
 * @param body
 * @returns
 */
export async function addGroup(body: {
  groupName: string;
  memberList: {
    memberId: string;
    memberType: 1 | 2;
  }[];
}) {
  try {
    const result = await gatewayInstance.request({
      api: "screen.addGroup",
      method: "POST",
      // @ts-ignore
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

/**
 * 修改组名
 * @param body
 * @returns
 */
export async function editGroupName(body: { groupName: string; groupId: string }) {
  try {
    const result = await gatewayInstance.request({
      api: "screen.changeGroupName",
      method: "POST",
      // @ts-ignore
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

/**
 * 删除组
 * @param body
 * @returns
 */
export function removeGroup(body: { groupId: string }) {
  try {
    const result = gatewayInstance.request({
      api: "screen.removeGroup",
      method: "POST",
      // @ts-ignore
      body
    });
    return result;
  } catch (error) {
    return null;
  }
}

/**
 * 取消组内成员
 * @param body
 * @returns
 */
export function removeGroupMember(body: { groupId: string; memberId: string; memberType: 1 | 2 }) {
  try {
    const result = gatewayInstance.request({
      api: "screen.removeGroupMember",
      method: "POST",
      // @ts-ignore
      body
    });
    return result;
  } catch (error) {
    return null;
  }
}

/**
 * 获取冬奥部门截取配置信息
 * @returns
 */
export function getDepartmentConfig() {
  try {
    const result = gatewayInstance.request({
      api: "screen.getDepartmentConfig",
      method: "POST",
      // @ts-ignore
      body: {}
    });
    return result;
  } catch (error) {
    return null;
  }
}

/**
 * 获取冬奥通知配置信息
 * @returns
 */
export function getNotifyConfig() {
  try {
    const result = gatewayInstance.request({
      api: "screen.getNotifyConfig",
      method: "POST",
      // @ts-ignore
      body: {}
    });
    return result;
  } catch (error) {
    return null;
  }
}

/**
 *
 * 部门数据(左侧导航)
 * @returns
 * @param body
 */
export async function getSimpleDeptInfo(body: { deptId?: string; displaySubDept?: boolean }) {
  try {
    const result = await gatewayInstance.request({
      api: addressBookApiConfig().simpleDeptInfo,
      method: "POST",
      // @ts-ignore
      body
    });
    return result;
  } catch (error) {
    return null;
  }
}
// 获取单位和部门的平布列表数据
export async function getEbookUnitDeptAndInnerDeptInfo() {
  try {
    const result: any = await gatewayInstance.request({
      api: "ebook.gov.getEbookUnitDeptAndInnerDeptInfo",
      method: "POST"
      // @ts-ignore
      // body,
    });
    return [result, null];
  } catch (error) {
    return [null, error?.message.toString()];
  }
}

/**
 *
 * 用户数据（总体）
 * @returns
 * @param body
 */
export async function getEbookOrgInfo(body: { orgId?: string; displaySubDept?: boolean }) {
  return gatewayInstance.request({
    api: addressBookApiConfig().ebookOrgInfo,
    method: "POST",
    // @ts-ignore
    body
  });
}

/**
 *
 * 用户数据（总体）
 * @returns
 * @param body
 */
export async function getEbookDeptInfo(body: { deptId?: string; displaySubDept?: boolean }) {
  try {
    const imService = ImService.getInstance();
    // await imService.refreshDeptVersion();
    if (!body.deptId) {
      const currentEmployee = await imService.getCurrentEmployee();
      body.deptId = currentEmployee?.deptId;
    }
    const result = await getEbookDeptInfoList(body);
    return result || {};
  } catch (error) {
    return {};
  }

  // return gatewayInstance.request({
  //     api: addressBookApiConfig().ebookDeptInfo,
  //     method: 'POST',
  //     // @ts-ignore
  //     body,
  // });
}

export async function getVirtualUserDetail(params: {
  userId: string;
  teamId: string;
  appId: string;
  rootOrgId?: string;
}) {
  return gatewayInstance.request({
    api: addressBookApiConfig().virtualUserDetail,
    method: "POST",
    body: params
  });
}

export async function getEBookUserDetail(params: {
  userId: string;
  teamId: string;
  appId: string;
  isMulti?: boolean;
}) {
  return gatewayInstance.request({
    api: addressBookApiConfig().ebookUserDetail,
    method: "POST",
    body: { isMulti: true, ...params }
  });
}

export async function saveEUserSetting(params: { settingCode: string; settingContent: string }) {
  return gatewayInstance.request({
    api: "euser.saveUserSetting",
    method: "POST",
    body: params
  });
}

export async function getEbookDeptDesc(deptId = "", teamId: string) {
  return gatewayInstance
    .request({
      api: "ebook.gov.getDeptDesc",
      method: "POST",
      body: { deptId, teamId }
    })
    .catch((err) => {
      console.log("getEbookDeptDesc-err", err);
    });
}

// 获取用户的所有项目
export function getMyProjects(body: { searchText: string } = { searchText: "" }) {
  return request({
    api: "work.project.findMyProjects",
    body
  });
}

// 获取用户状态
export async function getPageExternalContactsApprInfoReq(
  body: PageExternalContactsApprInfoReqParam
): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "focus.pageExternalContactsApprInfo",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 获取用户状态
export async function getEmplApproveListByEmplSource(body: EmplApproveList): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "focusadmin.enterprise.address.getEmplApproveListByEmplSource",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 管理端消息通知列表
export async function getManagerApproveRecordsReq(body: {
  pageNo: number; // 页数
  pageSize: number; // 每页数量
  /** 0:我发出的, 1:我收到的 */
  dataType?: number;
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.managerApproveRecords",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 管理端操作：账号延期/停用/恢复
export async function changeExtAccountStatus(body: {
  /**
   * 4:延期, 5:停用, 6:恢复, 8:删除
   */
  type: number;
  userId?: string;
  teamId: string;
  userIds?: string[];
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.changeExtAccountStatus",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 管理端操作：账号延期/停用/恢复
export async function transferEmpls(body: {
  reason: string;
  userIds: string[]; // 外部联系人userId
  toUserId: string; // 新的管理者userId
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.transferEmpls",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 人员基本状态
export enum UserStatus {
  /** 未激活 */
  UN_ACTIVATE = 1,
  /** 正常 */
  NORMAL = 1 << 1,
  /** 已停用 */
  UN_ENABLE = 1 << 2,
  /** 已过期 */
  UN_ENABLE_EXPIRE = 1 << 3,
  /** 转交中 */
  TRANSFERRING = 1 << 4
}
// 管理端外部联系人管理列表
export async function getManageExtEmpls(body: {
  pageNo: number; // 页数
  pageSize: number; // 每页数量
  keyword?: string; // 搜素关键字, 非必填
  status?: null | number; // 人员状态, 非必填
  validDateLt?: null | number; // 到期时间止, 毫秒时间戳, 非必填
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.getManageExtEmpls",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 管理端审核延期申请
export async function approveAccountEXP(body: {
  recordId: number; // AI卡片里审核在extend中, 消息通知列表里参见返回的字段
  result: number; // 0:驳回, 1:通过
  apprOption: string;
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.approveAccountEXP",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 管理端请求外部联系人账号操作记录
export async function getExtEmplOperateRecord(body: {
  userId: string;
  teamId: string;
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.getExtEmplOperateRecord",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 外部联系人申请延期
export async function getApplyAccountEXPReq(body: { applyReason: string }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.applyAccountEXP",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 外部联系人消息通知列表
export async function getExtEmplMsgNotifyRecords(): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.getExtEmplMsgNotifyRecords",
      method: "POST"
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 获取用户状态
export async function getCodeInfo(body: { codeType: "workStatus" | "autoReply" }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "euser.getCodeInfo",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 保存用户状态
export async function saveUserSetting(body: {
  settingCode: "workStatus" | "autoReply";
  bizChildType: {
    workStatus?: WorkStatusItem;
    autoReply?: any;
  };
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "euser.saveUserSetting",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 获取用户设置
export async function getUserSetting(body: {
  settingCode: "workStatus" | "autoReply";
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "euser.getUserSetting",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function getIsAddFriends(param: { friendUserId: string }): Promise<any> {
  try {
    const data = await gatewayInstance.request({
      api: "ebook.isAddFriends",
      method: "POST",
      body: param
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function getAllRelationShip(param: {
  oppoUserId: string;
  oppoTeamId: string;
  appId: string;
}): Promise<any> {
  try {
    const data = await gatewayInstance.request({
      api: "ebook.getAllRelationShip",
      method: "POST",
      body: param
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 删除好友
export async function removeEFriend(param: {
  pin: string;
  app: string;
  teamId: string;
}): Promise<any> {
  try {
    const data = await gatewayInstance.request({
      api: "efriend.removeFriend",
      method: "POST",
      body: param
    });
    return [data, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

/**
 * @description 常用联系人可见规则
 */
export async function getFirstLoginList(): Promise<any> {
  try {
    const data = await gatewayInstance.request({
      api: "ebook.gov.getFirstLoginList",
      method: "POST"
    });
    return [data, null];
  } catch (error) {
    return [null, error?.message];
  }
}

// 系统管理员列表
export async function getMyAdministratorsList(body: { deptId: string }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "authz.getMyAdministrators",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 外边联系人管理者
export async function getExtManager(): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.getExtManager",
      method: "POST"
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 外边联系人管理者
export async function sendActiveMsg(body: { userId: string; teamId: string }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.ext.sendActiveMsg",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 外边联系人管理者
export async function readFriendApplies(body: { applies: any }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "efriend.readFriendApplies",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 工作条线
export async function getWorkLineEbook(body: { nodeId: string; version: number }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.gov.getWorkLineEbook",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 公共账号
export async function getManagedPublicEmplList(): Promise<any> {
  try {
    const result: any = await gatewayInstance.request({
      api: "ebook.gov.getManagedPublicEmplList",
      method: "POST"
    });
    const list = result.publicEmplInfos.map((i: any) => ({
      ...i,
      name: i.fields.find((f: any) => f.key === "name")?.val || "",
      avatar: i.fields.find((f: any) => f.key === "avatar")?.val || "",
      desc: getDeptPositionDesc({
        deptName: i.partTimeTitleDeptInfo?.[0]?.deptName || "",
        titleName: i.partTimeTitleDeptInfo?.[0]?.titleName || "",
        unitName: i.partTimeTitleDeptInfo?.[0]?.unitName || "",
        userType: i.userType
      })
    }));

    return [list, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
// 获取公共人员使用人列表
export async function getPublicEmplUserList(userId: string): Promise<any> {
  try {
    const result: any = await gatewayInstance.request({
      api: "ebook.gov.getPublicEmplUserList",
      method: "POST",
      body: { userId }
    });
    const list = result.userList.map((i: any) => ({
      ...i,
      name: i.fields.find((f: any) => f.key === "name")?.val || "",
      avatar: i.fields.find((f: any) => f.key === "avatar")?.val || "",
      desc: getDeptPositionDesc({
        deptName: i.partTimeTitleDeptInfo?.[0]?.deptName || "",
        titleName: i.partTimeTitleDeptInfo?.[0]?.titleName || "",
        unitName: i.partTimeTitleDeptInfo?.[0]?.unitName || "",
        userType: i.userType
      })
    }));

    return [list, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 操作公共人员使用人
export async function setPublicEmplUsers(body: {
  userIds: string[];
  type: number;
  publicUserId: string;
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.gov.setPublicEmplUsers",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 通讯录管理权限
export async function getEbookManagerAuth(): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.gov.getEbookManagerAuth",
      method: "POST"
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

// 创建/更新标签
export async function setTag(body: { tagId?: string; tagName: string }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.set",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function removeTag(body: { tagIds: string[] }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.remove",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function getTagList(): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.get",
      method: "POST"
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function getTagEmpls(tagId: string): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.getEmpls",
      method: "POST",
      body: { tagId }
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export async function setTagEmpls(body: {
  operateType: number; // 操作类型, 0:删除, 1:添加
  tagId: string;
  userIds: { appId: string; userId: string; teamId: string }[];
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.setEmpls",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

/**
 * 标签排序
 */
export async function sortTag(body: { sorts: { tagId: string; sortNum: string }[] }): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.sort",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}
export async function setTagForEmpl(body: {
  targetAppId: string;
  targetUserId: string;
  targetTeamId: string;
  tagIds: any[];
}): Promise<any> {
  try {
    const result = await gatewayInstance.request({
      api: "ebook.tag.setForEmpl",
      method: "POST",
      body
    });
    return [result, null];
  } catch (error) {
    return [null, error.message.toString()];
  }
}

export function getEbookDeptCount(deptIds: any[]) {
  try {
    const result = gatewayInstance.request({
      api: "ebook.gov.getEbookDeptCount",
      method: "POST",
      // @ts-ignore
      body: { deptIds }
    });
    return result;
  } catch (error) {
    return null;
  }
}